import axiosInstance from './axiosInstance';

// Download the signed agreement PDF for a specific user.
// Backend: GET /api/Agreement/Download/{userId} — 404 if user has no accepted agreement.
// Streams the PDF as a blob and triggers a browser download.
export const downloadAgreement = async (userId) => {
    const res = await axiosInstance.get(`/Agreement/Download/${userId}`, { responseType: 'blob' });
    const cd = res.headers['content-disposition'];
    let fileName = `agreement-${userId}.pdf`;
    if (cd) {
        const m = cd.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
        if (m) fileName = decodeURIComponent(m[1].replace(/"/g, '').trim());
    }
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url; a.download = fileName;
    document.body.appendChild(a); a.click(); a.remove();
    window.URL.revokeObjectURL(url);
};
